<template>
  <div class="large-app-menu-bar">
    <v-app-bar
      class="login-app-bar"
      :class="isAdmin ? 'admin-menu' : 'user-menu'"
      flat
    >
      <img alt="Vue logo" src="@/assets/header_logo.png" height="27.04px" />
      <v-spacer></v-spacer>
      <svg-icon
        v-if="isAdmin"
        iconClass="awesome-user-alt"
        class="user-role-svg-icon"
      />
      <span class="user-role-type" v-if="isAdmin">管理者用</span>
    </v-app-bar>
    <router-view></router-view>
    <v-footer
      :class="isAdmin ? 'admin-footer' : 'user-footer'"
      class="d-flex footer-span"
    >
      <div>
        <span>© zen-aron All rights reserved.</span>
      </div>
    </v-footer>
  </div>
</template>
<script>
export default {
  name: "LoginNavigationBar",
  computed: {
    isAdmin() {
      return this.$route.path.startsWith("/admin");
    },
  }
}
</script>
<style lang="scss" scoped>
.large-app-menu-bar {
  .login-app-bar.admin-menu {
    height: 60px !important;
    background-color: $admin-primary !important;
    position: absolute;
  }
  .login-app-bar.user-menu {
    height: 60px !important;
    background-color: $user-nav-color !important;
    border-bottom: 3px solid $user-color-title;
  }
  .user-role-svg-icon {
    color: $admin-secondary;
    margin-right: 5px;
    height: 22.6px;
    width: 22.6px;
  }
  .user-role-type {
    color: $dark-blue;
    padding-right: 60px;
    font-size: $size-login-banner;
    font-family: $family-normal;
    // font-style: oblique;
  }
  .large-app-bar-container {
    padding: 0;
  }
  .footer-span {
    flex-direction: row-reverse;
  }
  /*Responsive For Mobile Size*/
  @media screen and (max-width: $size-mobile) {
    .app-title {
      padding-left: 0;
      font-size: $size-tip;
    }
    .user-role-svg-icon {
      color: $admin-secondary;
      height: 17px;
      width: 17px;
    }
    .user-role-type {
      color: $black;
      padding-right: 0;
      font-size: $size-tip;
      font-family: $family-normal;
      // font-style: oblique;
      margin-top: 3px;
    }
    .footer-span {
      justify-content: center;
      flex-direction: unset;
    }
  }
}
.v-footer {
  bottom: 0;
  width: 100%;
  height: 60px;
  position: absolute;
}

.v-footer.admin-footer {
  background-color: $admin-primary !important;
  color: $white;
}
.v-footer.user-footer {
  background-color: $user-footer-bg !important;
  border-top: 3px solid $user-color-title;
  color: $black;
}
</style>
